import { imgFade } from '~~/app/utils/imgFade'

/**
 * Rejestruje dyrektywę `v-img-fade` (łagodne pojawianie się zdjęć po doczytaniu).
 *
 * Plugin jest UNIWERSALNY (nie `.client`), by dyrektywa rozwiązywała się też w SSR
 * (inaczej `resolveDirective("img-fade")` zwraca undefined na serwerze i Vue
 * ostrzega). Sam efekt jest jednak czysto kliencki: dyrektywa ma tylko hook
 * `mounted` (nie odpala się w SSR) i nie definiuje `getSSRProps`, więc serwer nie
 * dokłada żadnej klasy → obraz jest domyślnie widoczny (zero ryzyka „niewidzialnej"
 * galerii bez JS / przy cache).
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('img-fade', imgFade)
})
